<div id="equivalences" class="container">
  <!--<div class="row degrade">-->
  <div class="row">

    <div>
      <div *ngFor="let item of fromComp">
        <label class="code textlabel">{{ item.code }}</label><label class="enonce textlabel">{{ item.enonce }}</label>
      </div>
    </div>
    <div class="fleches textlabel">
      <div *ngIf="statut == 'Identiques';else other_content">
        <i class="fa fa-arrows-h fa-lg"></i>
      </div>
      <ng-template #other_content><i class="fa fa-long-arrow-right fa-lg"></i></ng-template>
    </div>
    <div>
      <div *ngFor="let item of toComp">
        <label class="code textlabel">{{ item.code }}</label><label class="enonce textlabel">{{ item.enonce }}</label>
      </div>
    </div>
    <div class="statut">
      <label class="statut textlabel font-weight-bold">{{ statut }}</label>
    </div>
    <div class="ordre" *ngIf="isUserLoggedIn">
      <i class="fa fa-caret-up float-right fa-lg" aria-hidden="true" (click)="moveEquivalence(equivalence.equivalenceId,'UP')" *ngIf="equivalence.equivalenceId != first"></i>
      <i class="fa fa-caret-down float-left fa-lg" aria-hidden="true" (click)="moveEquivalence(equivalence.equivalenceId,'DOWN')" *ngIf="equivalence.equivalenceId != last"></i>
    </div>
    <div class="supprimer" *ngIf="isUserLoggedIn">
      <a tooltip="Supprimer cette équivalence" containerClass="cemeq-tooltip" (click)="deleteEquivalence(equivalence.equivalenceId)">
        <i class="fa fa-trash fa-lg" style="color:grey;cursor:pointer;" aria-hidden="true"></i>
      </a>
    </div>
  </div>
  <hr class="filet" style="display:none" />
</div>
